import { useState } from 'react';
import { returnDayOfWeek } from '../../../../lib/returnDayOfWeek';
import { AnimatePresence, motion } from 'motion/react';
import { transition, variants } from './variants';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize';
import styles from './RulesList.module.css';

export default function RulesList(props) {

    const { list, handleStartEditSchedule, isEditingOrCreating, handleConfirmDelete, scheduleId } = props;

    const { width } = useWindowSize();

    const [ remove, setRemove ] = useState('');

    const deleteRule = (id) => {
        handleConfirmDelete(id);
        setRemove(false);
    };

    return (
        <div className={styles.listContainer}>
            <div className={styles.header}>Rules List</div>
            <AnimatePresence initial={false} mode='wait'>
                {list?.length > 0 ? (
                    <motion.div
                        key='list'
                        className={styles.listWrapper}
                        transition={transition}
                        variants={variants}
                        initial='initial'
                        animate='animate'
                        exit='initial'
                    >
                        <div className={styles.list}>
                            {list.map(sched => (
                                <motion.div 
                                    key={sched.id}
                                    className={`${styles.scheduleOption} ${(isEditingOrCreating && scheduleId === sched.id) ? styles.editing : ''}`} 
                                    transition={transition}
                                    variants={variants}
                                    initial={false}
                                    animate={(isEditingOrCreating && scheduleId === sched.id) ? 'disabled' : 'enabled'}
                                >
                                    <div className={styles.left}>
                                        <div className={styles.top}>
                                            <div className={styles.scheduleId} title={sched.name || sched.id}>{sched.name ? 'Name' : 'ID'}: <span>{sched.name || sched.id}</span></div>
                                            {(isEditingOrCreating && scheduleId === sched.id) && (<div className={styles.pending}>Pending</div>)}
                                        </div>
                                        <div className={styles.bottomWrapper}>
                                            <div className={styles.bottom}> 
                                                <div className={styles.scheduleDetails} >Days: <span>{(sched.day.enabled && sched.day.value.length > 0) ? returnDayOfWeek(sched.day.value) : 'N/A'}</span></div>
                                                <div className={styles.scheduleDetails} >Device: <span>{(sched.device.enabled && sched.device.value) ? returnRuleDevice(sched.device.value) : 'N/A'}</span></div>
                                                <div className={styles.scheduleDetails} >Time: <span>{(sched.time.enabled && sched.time.value.start && sched.time.value.end && sched.time.value.timezone) ? <>{sched.time.value.start} - {sched.time.value.end} ({sched.time.value.timezone})</> : 'N/A'}</span></div>
                                                <div className={styles.scheduleDetails} >Type: <span>{returnRuleType(sched.resources?.type)}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.right} style={(isEditingOrCreating && scheduleId === sched.id) ? {pointerEvents: 'none'} : {pointerEvents: 'initial'}}>
                                        <button 
                                            className={styles.editBtn}
                                            onClick={() => handleStartEditSchedule(sched.id)}
                                        >
                                            <i className='fa-regular fa-pen-to-square' />
                                            {width > 768 && 'Edit'}
                                        </button>
                                        <motion.div 
                                            className={styles.deleteWrap}
                                            transition={transition}
                                            variants={variants}
                                            initial={false}
                                            animate={remove !== sched.id ? 'smallWrap' : 'largeWrap'}
                                            custom={width}
                                        >
                                            <button
                                                className={styles.deleteBtn}
                                                style={{backgroundColor: `${remove !== sched.id ? '' : 'salmon'}`, color: `${remove !== sched.id ? '' : '#fff'}`}}
                                                onClick={remove !== sched.id ? () => setRemove(sched.id) : () => deleteRule(sched.id)}
                                            >
                                                <i className='far fa-trash-can' />
                                                {width > 768 ? remove === sched.id ? 'Confirm' : 'Remove' : ''}
                                            </button>
                                            <button
                                                className={styles.cancelBtn}
                                                style={{width: `${remove !== sched.id ? '100%' : '50%'}`}}
                                                onClick={() => setRemove('')}
                                            >
                                                <i className='far fa-xmark' />
                                                {width > 768 && 'Cancel'}
                                            </button>
                                        </motion.div>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>
                ) : (
                    <motion.div 
                        key='no-list'
                        className={styles.noRules}
                        transition={transition}
                        variants={variants}
                        initial='initial'
                        animate='animate'
                        exit='initial'
                    >
                        <span>Your account currently has no QR rules defined.</span>
                        This means any QR code scans are following the default settings, 
                        which might not be what you intend for tracking, redirects, or security.
                        To ensure your QR codes work exactly as you need them to, please take a moment to set up your rules now.
                        Click or tap the "New Rule" button above.
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

const returnRuleDevice = (device) => {
    switch(device) {
        case 'ios':
            return 'iOS';
        case 'android':
            return 'Android';
        case 'desktop':
            return 'Desktop';
        default:
            return 'N/A';
    };
};

const returnRuleType = (type) => {
    switch(type) {
        case 'link':
            return 'Link';
        case 'pdf':
            return 'PDF';
        case 'asset':
            return 'Liquid Label';
        default:
            return 'N/A';
    };
};